<template>
    <section class="share-header">
        <div class="logo">
            <img :src="logo2x" />
        </div>
        <button class="dowload" color="#FF6907" @click="download_app">{{ $t('downloadMsg') }}</button>
    </section>
</template>

<script>
import { logo2x } from '@/config/cdnResoureUrl'
export default {
    name: 'DownloadHeader',
    data() {
        return {
            logo2x,
        }
    },
    methods: {
        download_app() {
            window.location.href = 'https://h5.fotechwealth.com/m/'
        },
    },
}
</script>

<style lang="less" scoped>
@import url('../css/mixins.less');

.share-header {
    position: fixed;
    top: var(--nav-header-height);
    left: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;
    padding: 16px;
    background-color: #fff;

    .logo {
        text-align: center;

        img {
            width: 110px;
        }

        p {
            margin-top: 4px;
            margin-left: 8px;
            font-size: 12px;
            letter-spacing: 0.35em;
        }
    }

    .dowload {
        width: 52px;
        height: 28px;
        color: #fff;
        font-size: 14px;
        background-color: #ff6907;
        border: 1px solid;
        border-radius: 31px;
    }
}
</style>
